import React, { useState } from "react";

import "./styles.scss";

import {
    Container,
    Row,
    Col,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    UncontrolledAccordion
} from "reactstrap";
import InstagramFeed from "../../components/InstagramFeed/InstagramFeed";

const WhoWeAre = () => {
    const [open, setOpen] = useState('');

    const handleAccordion = (id) => {
        if (open === id) {
            setOpen('');
        } else {
            setOpen(id);
        }
    };

    const members = [
        {
            name: 'FRANCO COSTANZO',
            description: 'Ex futbolista profesional con más de 20 años de carrera en clubes de primer nivel de Sudamérica y Europa. Tras el retiro, además de completar el Programa FIFA/CIES en Management Deportivo, se desempeñó en distintos puestos administrativos tanto en la Universidad Católica de Chile como en el FC Basel de Suiza, donde fue representante del club para el mercado latinoamericano.',
            img: 'franco-costanzo',
            linkedin: 'franco-costanzo-467a56135',
        },
        {
            name: 'ALEJANDRO VARSKY',
            description: 'Profesional de la Comunicación y el Marketing Digital con más de 20 años de experiencia en el sector internacional. Gestó gran parte de su carrera en la FIFA donde, además de trabajar en la organización de cinco Copas Mundiales, lideró la estrategia de comunicación para el FIFA Ballon d’Or y los premios The Best. Actualmente se desempeña como Director de Comunicaciones en FIFPRO, el Sindicato Mundial de Futbolistas Profesionales.',
            img: 'alejandro-varsky',
            linkedin: 'alejandrovarsky',
        },
        {
            name: 'PABLO AIMAR',
            description: 'Ex futbolista profesional con más de 20 años de carrera en clubes de renombre en Argentina, Portugal, España y Malasia. Ligado a la educación y formación de jóvenes talentos, es actualmente seleccionador sub-15 y ayudante de campo de Lionel Scaloni en el representativo mayor de Argentina, con el que ganó la reciente Copa Mundial de la FIFA 2022.',
            img: 'pablo-aimar'
        },
        {
            name: 'GUSTAVO MELGAREJO',
            description: 'Líder financiero con formación en ingeniería y más de 25 años de experiencia exitosa en la gestión de operaciones, integración de fusiones y adquisiciones, expansión geográfica y proyectos de nuevos modelos de negocio. Se ha desempeñado en las industrias de Petróleo y Gas, Farma y Ciencias de la Vida tanto en América Latina como Europa y MEA.',
            img: 'gustavo-melgarejo',
            linkedin: 'gustavo-melgarejo-mba',
        },
        {
            name: 'ALBERT FERNÁNDEZ',
            description: 'Profesor de MBA y Executive Education en IESE y otras escuelas de negocio en Europa, Estados Unidos y América Latina con más de 30 años de experiencia empresarial. Desde 2009 se desempeña como Director de Finaves, los fondos de capital semilla del IESE que han ayudado a financiar el crecimiento de más de 50 startups en el ámbito internacional.',
            img: 'albert-fernandez',
            linkedin: 'alberto-fernandez-9710431',
        },
        {
            name: 'HERNÁN PELLEGRINI',
            description: 'Asesor jurídico mercantil con más de 15 años de experiencia en el sector de inversiones, especializado en fusiones y adquisiciones internacionales; inversiones de capital privado y gobierno corporativo en las industrias de Petróleo y Gas entre otros. Ha desarrollado su carrera en Medio Oriente donde actualmente se desempeña como asesor de un fondo soberano de inversión.',
            img: 'hernan-pellegrini',
            linkedin: 'hernan-pellegrini-a86a3514',
        },
    ];

    return (
        <>
            <Container fluid tag="main" className="who-we-are py-5">
                <Container tag="section">
                    <Row tag="article" className="justify-content-center">
                        <Col xs="12" className="text-center">
                            <h2 className="title">Miembros de nuestra junta directiva</h2>
                        </Col>
                        <Col md="10" className="text-center">
                            <p className="subtitle">Son <strong> líderes profesionales</strong>  que han realizado contribuciones importantes a nuestra industria. Cada uno de ellos aporta a la organización un conjunto propio de competencias y experiencia.</p>
                        </Col>
                    </Row>
                </Container>

                <Container tag="section" className="members pt-5">
                    <Row tag="article">
                        {members.map((member, i) => (
                            <Col tag="article" key={i} md="6" xl="4" className="member text-center">
                                <img src={`images/${member.img}.jpg`} alt={member.name} title={member.name} />
                                <UncontrolledAccordion flush toggle={() => handleAccordion(i)}>
                                    <AccordionItem>
                                        <AccordionHeader targetId={i}>
                                            {member.name}
                                        </AccordionHeader>
                                        <AccordionBody accordionId={i}>
                                            <p>{member.description}</p>
                                            {member.linkedin && <a href={`https://www.linkedin.com/in/${member.linkedin}/`} target="_blank" rel="noreferrer">Linkedin</a>}
                                        </AccordionBody>
                                    </AccordionItem>
                                </UncontrolledAccordion>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </Container>
            <InstagramFeed />
        </>
    );
};

export default WhoWeAre;